import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  style: {"color":"#5fc9b8","font-size":"22pt","text-transform":"capitalize"},
  class: "mt-2 d-flex justify-start align-center"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.dialog)
    ? (_openBlock(), _createBlock(_component_oss_dialog, {
        key: 0,
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialog) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '950px' : undefined,
        "min-height": !_ctx.$vuetify.display.mobile ? '950px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        title: "Bilan mensuel",
        "min-width": "90vw",
        onKeydown: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.dialog = false), ["esc"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "uploadDocument" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: _normalizeClass(!_ctx.$vuetify.display.mobile ? '' : 'pa-2')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    style: {"background-color":"transparent"},
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window, {
                        touchless: "",
                        style: {"min-height":"27vh"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "d-flex justify-center py-1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: _ctx.$vuetify.display.mobile ? '12' : '12',
                                    class: "my-0 pa-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: _ctx.$vuetify.display.mobile ? '12' : '1'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-chevron-left",
                                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.calendar.prev()))
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["cols"]),
                                          _createVNode(_component_v_col, {
                                            cols: _ctx.$vuetify.display.mobile ? '12' : '1'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$fa-chevron-right",
                                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.calendar.next()))
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["cols"]),
                                          _createVNode(_component_v_col, {
                                            cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.actualMonth) + " - " + _toDisplayString(_ctx.actualYear), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["cols"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["cols"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { class: "d-flex justify-center py-1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_calendar, {
                                    ref: "calendar",
                                    modelValue: _ctx.focus,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.focus) = $event)),
                                    events: _ctx.events,
                                    "event-color": _ctx.getEventColor,
                                    start: _ctx.dayCalendarStart,
                                    end: _ctx.dayCalendarEnd,
                                    color: "secondary",
                                    type: "month",
                                    "onClick:event": _ctx.showEvent,
                                    onChange: _ctx.updateDates
                                  }, null, 8, ["modelValue", "events", "event-color", "start", "end", "onClick:event", "onChange"]),
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.selectedOpen,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedOpen) = $event)),
                                    "close-on-content-click": false,
                                    activator: _ctx.selectedElement,
                                    "offset-x": "",
                                    "max-width": "350px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        color: "grey lighten-4",
                                        "min-width": "350px",
                                        flat: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_toolbar, {
                                            color: _ctx.selectedEvent.color,
                                            dark: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_toolbar_title, {
                                                innerHTML: _ctx.selectedEvent.affDate
                                              }, null, 8, ["innerHTML"]),
                                              _createVNode(_component_v_spacer),
                                              _createVNode(_component_v_btn, {
                                                text: "",
                                                color: "white",
                                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedOpen = false)),
                                                icon: "$close"
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["color"]),
                                          _createVNode(_component_v_card_text, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("span", {
                                                  style: {"font-weight":"bold","font-size":"12pt"},
                                                  innerHTML: _ctx.selectedEvent.grossAmount
                                                }, null, 8, _hoisted_2)
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("span", {
                                                  style: {"font-weight":"bold","font-size":"10pt"},
                                                  innerHTML: _ctx.selectedEvent.amounts
                                                }, null, 8, _hoisted_3)
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_card_actions, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_spacer),
                                              (_ctx.selectedEvent.type !== 'warning')
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    class: "mr-5",
                                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openTicketZEdition(_ctx.selectedEvent.zTill))),
                                                    variant: "text"
                                                  }, {
                                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                      _createTextVNode(" Ouvrir ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 1,
                                                    class: "mr-5",
                                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'ztillReceipts' }))),
                                                    variant: "text"
                                                  }, {
                                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                      _createTextVNode(" Créer ")
                                                    ])),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "activator"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "min-height", "fullscreen", "hide-overlay"]))
    : _createCommentVNode("", true)
}